const images = [
  {
    id: 1,
    src: "https://res.cloudinary.com/mookie-admin/image/upload/v1668887978/World%20Cup/Group_2219_nctxcx.png",
    alt: "Image 1",
  },
  {
    id: 2,
    src: "https://res.cloudinary.com/mookie-admin/image/upload/v1669222276/World%20Cup/Group_2218_pcugpu.png",
    alt: "Image 2 ",
  },
  {
    id: 3,
    src: " https://res.cloudinary.com/mookie-admin/image/upload/v1669336989/World%20Cup/Group_2218_zguubl.png",
    alt: "Image 3",
  },
];
export default images;
